<span class="overline">2D VIEW SETTINGS</span>

<h3-view-settings-opacity-slider
  [defaultLayerOpacity]="defaultLayerOpacity"
  [layerOpacityStore]="layerOpacityStore"
></h3-view-settings-opacity-slider>

@if (hasNonOrthographicOutput) {
  <h3-view-settings-slider
    [defaultValue]="defaultBrightness"
    [settingStore]="brightnessStore"
    label="Brightness"
    settingName="brightness"
  ></h3-view-settings-slider>

  <h3-view-settings-slider
    [defaultValue]="defaultContrast"
    [settingStore]="contrastStore"
    label="Contrast"
    settingName="contrast"
  ></h3-view-settings-slider>
}
<mat-divider></mat-divider>

<div>
  @if (hasRectangleTool) {
    <mat-checkbox
      color="primary"
      [nasModel]="showShapeDimensionsStore"
      (change)="trackShowDimensionsChange()"
    >
      <span class="caption">Show dimensions inside rectangles</span>
    </mat-checkbox>
  }
  <mat-checkbox
    color="primary"
    [nasModel]="hideOccludedShapesStore"
    (change)="trackHideOccludedShapesChange()"
  >
    <span class="caption">Hide occluded shapes</span>
  </mat-checkbox>
  <mat-checkbox color="primary" [nasModel]="alwaysShowSubpointsStore">
    <span class="caption">Always show subpoints</span>
  </mat-checkbox>
  <mat-checkbox color="primary" [nasModel]="swapLayerOnSelectStore">
    <span class="caption">Swap layer on select</span>
  </mat-checkbox>
  @if (hasNonOrthographicOutput) {
    <mat-checkbox color="primary" [nasModel]="zoomPanelEnabledStore">
      <span class="caption">Enable zoom panel</span>
    </mat-checkbox>
  }
  <h3-persist-checkbox></h3-persist-checkbox>
</div>
